import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

function Tooltip({ text }) {
  return (
    <span className="group relative inline-block ml-1 no-print">
      <button
        type="button"
        aria-label={typeof text === 'string' ? text : 'More info'}
        className="text-blue-500 cursor-help align-middle focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
      >
        <FaInfoCircle aria-hidden="true" />
      </button>
      <span
        role="tooltip"
        className="absolute z-10 hidden group-hover:block group-focus-within:block bg-gray-800 text-white text-sm rounded p-2 mt-1 min-w-[200px] max-w-xs right-0"
      >
        {text}
      </span>
    </span>
  );
}

export default Tooltip;
